import * as deviceapis_device_v1_capability_pb from "./v1/deviceapis_device_capability_v1.pb";
import * as deviceapis_device_v1_code_pb from "./v1/deviceapis_device_code_v1.pb";
import * as deviceapis_device_v1_common_pb from "./v1/deviceapis_device_common_v1.pb";
import * as deviceapis_device_v1_concierge_pb from "./v1/deviceapis_device_concierge_v1.pb";
import * as deviceapis_device_v1_dtmf_pb from "./v1/deviceapis_device_dtmf_v1.pb";
import * as deviceapis_device_v1_encryption_profile_pb from "./v1/deviceapis_device_encryption_profile_v1.pb";
import * as deviceapis_device_v1_fr_pb from "./v1/deviceapis_device_fr_v1.pb";
import * as deviceapis_device_v1_ftp_pb from "./v1/deviceapis_device_ftp_v1.pb";
import * as deviceapis_device_v1_gate_pb from "./v1/deviceapis_device_gate_v1.pb";
import * as deviceapis_device_v1_ntp_pb from "./v1/deviceapis_device_ntp_v1.pb";
import * as deviceapis_device_v1_reader_pb from "./v1/deviceapis_device_reader_v1.pb";
import * as deviceapis_device_v1_relay_pb from "./v1/deviceapis_device_relay_v1.pb";
import * as deviceapis_device_v1_rfid_pb from "./v1/deviceapis_device_rfid_v1.pb";
import * as deviceapis_device_v1_room_pb from "./v1/deviceapis_device_room_v1.pb";
import * as deviceapis_device_v1_rtsp_pb from "./v1/deviceapis_device_rtsp_v1.pb";
import * as deviceapis_device_v1_sac_pb from "./v1/deviceapis_device_sac_v1.pb";
import * as deviceapis_device_v1_safe_emergency_pb from "./v1/deviceapis_device_safe_emergency_v1.pb";
import * as deviceapis_device_v1_safe_emergency_file_pb from "./v1/deviceapis_device_safe_emergency_file_v1.pb";
import * as deviceapis_device_v1_safe_osd_pb from "./v1/deviceapis_device_safe_osd_v1.pb";
import * as deviceapis_device_v1_sip_pb from "./v1/deviceapis_device_sip_v1.pb";
import * as deviceapis_device_v1_sos_pb from "./v1/deviceapis_device_sos_v1.pb";
import * as deviceapis_device_v1_syslog_pb from "./v1/deviceapis_device_syslog_v1.pb";
import * as deviceapis_device_v1_system_pb from "./v1/deviceapis_device_system_v1.pb";
import * as deviceapis_device_v1_ticker_pb from "./v1/deviceapis_device_ticker_v1.pb";
import * as deviceapis_device_v1_update_pb from "./v1/deviceapis_device_update_v1.pb";
import * as deviceapis_device_v1_user_pb from "./v1/deviceapis_device_user_v1.pb";
import * as deviceapis_device_v1_video_pb from "./v1/deviceapis_device_video_v1.pb";

export default {
  v1: {
    resources: {
      capability: deviceapis_device_v1_capability_pb,
      code: deviceapis_device_v1_code_pb,
      common: deviceapis_device_v1_common_pb,
      concierge: deviceapis_device_v1_concierge_pb,
      dtmf: deviceapis_device_v1_dtmf_pb,
      encryptionProfile: deviceapis_device_v1_encryption_profile_pb,
      fr: deviceapis_device_v1_fr_pb,
      ftp: deviceapis_device_v1_ftp_pb,
      gate: deviceapis_device_v1_gate_pb,
      ntp: deviceapis_device_v1_ntp_pb,
      reader: deviceapis_device_v1_reader_pb,
      relay: deviceapis_device_v1_relay_pb,
      rfid: deviceapis_device_v1_rfid_pb,
      room: deviceapis_device_v1_room_pb,
      rtsp: deviceapis_device_v1_rtsp_pb,
      sac: deviceapis_device_v1_sac_pb,
      safeEmergency: deviceapis_device_v1_safe_emergency_pb,
      safeEmergencyFile: deviceapis_device_v1_safe_emergency_file_pb,
      safeOsd: deviceapis_device_v1_safe_osd_pb,
      sip: deviceapis_device_v1_sip_pb,
      sos: deviceapis_device_v1_sos_pb,
      syslog: deviceapis_device_v1_syslog_pb,
      system: deviceapis_device_v1_system_pb,
      ticker: deviceapis_device_v1_ticker_pb,
      update: deviceapis_device_v1_update_pb,
      user: deviceapis_device_v1_user_pb,
      video: deviceapis_device_v1_video_pb,
    },
  },
};
